// extracted by mini-css-extract-plugin
export var addressContainer = "styles-module--address-container--ZAEcY";
export var contactSection = "styles-module--contact-section--iDDNM";
export var country = "styles-module--country--MlAlg";
export var primary = "#06004d";
export var secondary = "#4dafd7";